import { RhythmScreen } from './RhythmScreen';

export function RhythmRoute() {
  return <RhythmScreen />;
}
